module.exports = __webpack_public_path__ + "img/red-circle-table-6.14b3e86a.png";